<template>
    <div class="employer-contact container">
        <div class="row">
          <amf-input label="Your E-mail" v-model="data.email" :validator="$v.data.email" :columns="2"></amf-input>
        </div>
        <div class="row">
          <amf-input label="NPN" v-model="data.npn"></amf-input>
        </div>
        <label class="amf-label mt-1">What products would you like included in your quote?</label>
        <amf-checkbox
          label="Flexible Spending Accounts (FSA)"
          v-model="data.fsa">
        </amf-checkbox>
        <amf-checkbox
          label="Commuter Reimbursement Accounts (CRA)"
          v-model="data.cra">
        </amf-checkbox>
        <amf-checkbox
          label="Dependent Care Accounts (DCA)"
          v-model="data.dca">
        </amf-checkbox>
        <amf-checkbox
          label="Health Savings Accounts (HSA)"
          v-model="data.hsa">
        </amf-checkbox>
        <amf-checkbox
          label="Health Reimbursement Accounts (HRA)"
          v-model="data.hra">
        </amf-checkbox>
        <amf-checkbox
          label="Compliance Services"
          v-model="data.complianceServices">
        </amf-checkbox>
        <amf-checkbox
          label="Premium Only Plan Documents (POP)"
          v-model="data.pop">
        </amf-checkbox>
        <amf-checkbox
          label="COBRA"
          v-model="data.cobra">
        </amf-checkbox>
        <amf-checkbox
          label="COBRA (for Aetna-sponsored medical plans only)"
          v-model="data.cobraAetna">
        </amf-checkbox>
        <div class="row">
          <amf-input label="Company Name" v-model="data.companyName" :validator="$v.data.companyName" :columns="2"></amf-input>
          <amf-datepicker label="Plan Start Date" :hideCalendar="true" v-model="data.planStartDate"></amf-datepicker>
        </div>
        <div class="row">
          <amf-input label="Number of Eligible Employees" v-model="data.numberOfEligibleEmployees" :validator="$v.data.numberOfEligibleEmployees"></amf-input>
          <amf-input label="Number of Current Participants (if applicable)" v-model="data.numberOfCurrentParticipants" :validator="$v.data.numberOfCurrentParticipants" :columns="2"></amf-input>
        </div>
    </div>
</template>

<script>
export default{
   props: [
            "title",
        ],
  data () {
    return {
      data: {
        npn: null,
        fsa: false,
        cra: false,
        dca: false,
        hsa: false,
        hra: false,
        complianceServices: false,
        pop: false,
        cobra: false,
        cobraAetna: false,
        companyName: null,
        planStartDate: null,
        numberOfEligibleEmployees: null,
        numberOfCurrentParticipants: null,
        ...amfx.clone('userProfile', 'email'),
      }
    }
  },
  computed:{
    ...amfx.map('userProfile', 'email'),
    minimumPlansSelected(){
      return this.data.fsa != false || this.data.cra != false || this.data.dca != false || this.data.hsa != false || this.data.hra != false 
        || this.data.complianceServices != false || this.data.pop != false || this.data.cobra != false || this.data.cobraAetna != false
    },
  },
  methods: {
    async save(){
      let dataTemp = _.clone(this.data);
      romeApi.post(`/broker/quote`, dataTemp); 
    },
    validate() {
        if(!this.minimumPlansSelected){
            return "Please select at least one product for your quote.";
        }
        return;
    },
  },
  validations() {
    return {
      data: {
          companyName: v.build(v.required()),
          email: v.build(v.required(), v.email()),
          numberOfEligibleEmployees: v.build(v.required(), v.integer()),
          numberOfCurrentParticipants: v.build(v.integer()),
          planStartDate: v.build(v.date()),
      }
    }
  }  
}
</script>


// WEBPACK FOOTER //
// src/broker/RequestAQuote.vue